<template>
  <div class="preloader-5"></div>
</template>

<script>
export default{
  name: "preloaderComponent",
  props: [
    'styles'
  ]
}
</script>

<style scoped>
</style>
